// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".onfido-sdk-ui-Capture-CountrySelector-countrySelector .ods-select{max-width:unset}.onfido-sdk-ui-Capture-CountrySelector-countrySelector .ods-select-output{display:-webkit-box;display:-webkit-flex;display:flex}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_animation_duration": "200ms",
	"countrySelector": "onfido-sdk-ui-Capture-CountrySelector-countrySelector"
};
export default ___CSS_LOADER_EXPORT___;
